import "./Footer.css"

export default function Footer() {
  return (
    <footer class="footer">
    <div class="reveal container">
      <a href="#"> 
        <h3 class="footer__logo"><img src="/assets/VMLogo3.png" alt="logo" ></img>
        </h3>
        
    </a>

    

      <div class="footer__links col1">
        <a href="#Hero">About Me</a>
        <a href="#Contact">Contact</a>
        
      </div>

      <div class="footer__links col2">
        <a href="https://www.linkedin.com/in/vaishali7/">LinkedIn</a>
        <a href="#Portfolio">My work</a>
      </div>

     

      
    </div>
   
    <div class="footer__copyright">
        &copy; Vaishali Mehmi. All Rights Reserved.
      </div>
    <div class="attribution">
      <a href="https://github.com/vm799">Coded by PinkPistachioButterfly</a>.
      
    </div>
  </footer>
  )
}


